import * as ACTION_TYPES from '@stores/actions/action_types'
export interface PageFormStateType {
  isLoading: boolean
  isDirty: boolean
  isToast: boolean
  toastMessage: string
}
export const initialState = {
  isLoading: false,
  isDirty: false,
  isToast: false,
  toastMessage: '',
}
const PageFormReducer = (state: PageFormStateType, action: A) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_PAGE_FORM:
      return {
        ...state,
        ...action.data,
      }
    default:
      return state
  }
}
export default PageFormReducer
